import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = { logo_path: null, primary_color: "#2B8048", accent_color: "#C8402F", company_name: "Smartkey" };
const BrandCtx = createContext({ settings: DEFAULTS, setSettings: () => {}, reload: () => {} });

const hexToRgb = (hex) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
};

export const applyColors = (primary, accent) => {
  const root = document.documentElement;
  const p = hexToRgb(primary);
  const a = hexToRgb(accent);
  if (p) root.style.setProperty("--brand", p);
  if (a) root.style.setProperty("--brand-2", a);
};

export function BrandProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      if (data && typeof data === "object") setSettings({ ...DEFAULTS, ...data });
    } catch {
      setSettings(DEFAULTS);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    applyColors(settings.primary_color, settings.accent_color);
  }, [settings.primary_color, settings.accent_color]);

  return <BrandCtx.Provider value={{ settings, setSettings, reload }}>{children}</BrandCtx.Provider>;
}

export const useBrand = () => useContext(BrandCtx);
